<template>
  <section class="hebergementSection">
    <div class="giteContainer filNav">
      <router-link to="/">Bienvenue</router-link>
      <span>></span>
      <router-link to="/nos-hebergements" title="Nos différents Hébergements">Hébergements</router-link>
      <span>></span>
      <a>{{ listHeb[categorie].title }}</a>
    </div>

    <section class="giteContainer presentation">
      <div class="somePadd">
        <h2>{{ listHeb[categorie].title }}</h2>
        <p class="biggerText" v-html="listHeb[categorie].description"></p>

        <p class="" v-html="listHeb[categorie].subDesc"></p>

        <div class="resaBtnBox">
          <!-- <a @click="$parent.showReservation = !$parent.showReservation">RÉSERVER</a> -->
          <a href="/tarifs-et-reservation">TARIF & RESERVATIONS</a>
        </div>
      </div>
      <div class="imgViewer">
        <Slideshow sliderheight="500px" rightnav_class="fas fa-angle-right fa-3x"
          leftnav_class="fas fa-angle-left fa-3x">
          <div v-for="(img) in listHeb[categorie].imgs" :key="img">
            <img :src="getImg(img)" alt="Gite en lebé" />
          </div>
        </Slideshow>

        <p class="situationText">
          Situation : à 6km de la gare de Gimont, à 50km de Toulouse et de l'aéroport de Blagnac.
          <router-link to="/contact" title=" plan page contact">Plan d'accès cliquez ici</router-link>
        </p>
      </div>
    </section>

    <section class="giteContainer">
      <br />
      <p class="biggerText">
        Le gîte se situe au cœur d’une exploitation agricole aujourd’hui conduite en agriculture biologique. Un choix qui reflète notre volonté d'un travail en harmonie avec la nature, en respectant les sols et le vivant. Ici, l’agriculture se veut à taille humaine, attentive à l'environnement et tournée vers des pratiques durables. Un cadre authentique et apaisant, en cohérence avec l’esprit du lieu.
      </p>
      <br />
    </section>

    <Extra></Extra>
    <GreenBarContact></GreenBarContact>
  </section>
</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import GreenBarContact from "@/components/GreenBarContact.vue";
import Extra from "@/components/Extra.vue";

export default {
  name: "HebergementItem",

  computed: {
    mainImage: {
      get: function () {
        return require("@/assets/images/" +
          this.listHeb[this.categorie].imgs[this.imgToCatch]);
      },
    },
  },
  components: {
    Slideshow,
    GreenBarContact,
    Extra
  },

  data: function () {
    return {
      imgToCatch: 1,
      categorie: "",
      listHeb: [
        {
          title: "Le gîte",
          description: `Le Gîte d'En Lébé à Touget dans le Gers : une location de vacances idéale d'une capacité jusqu’à 15 personnes. Plongez dans la piscine ou retrouvez vous autour de la cheminée... pour des vacances inoubliables en famille au cœur de la Gascogne. Parking privatif fleuri et ombragé gratuit réservé à votre arrivée, menant au grand jardin arboré avec terrain de pétanque éclairé et mobilier de jardin pour des moments conviviaux entre amis ou famille nombreuse.
            `,
          subDesc: `Piscine privative <br> Labellisé Gîtes de France 3 épis et Tourisme & Handicap, ce gîte de 290 m² offre un grand espace de vie avec cheminée cosy, cuisine pro parfaitement équipée (2 fours, 2 frigos) pour repas de famille animés. <br>
          Rez-de-chaussée accessible PMR : 3 grandes chambres spacieuses, chacune avec salle de bain et sanitaires privatifs, climatisation réversible et TV écran plat. <br>
          À l'étage : 1 chambre (lit simple + double), grand dortoir 8 lits simples (climatisés), 2 salles de douche et 2 sanitaires indépendants. Literie de qualité ou draps fournis, wifi gratuit partout. <br> Toutes les chambres sont climatisés.
              `,
          imgs: [
            "grandgite/Cuisine.jpg",
            "grandgite/dortoirA.jpg",
            "grandgite/P1070847.jpg",
            "grandgite/P1070860.jpg",
            // "grandgite/P1070885.jpg",
            // "grandgite/P1070887.jpg",
            // "grandgite/P1070893.jpg",
            "grandgite/terrainpetanque.jpg",
            "grandgite/1000091582.jpg",
            "grandgite/1000091590.jpg",
            "grandgite/chambre.jpg",
            "grandgite/chambre2.jpg",
            "grandgite/chambrechat.jpg",
            "grandgite/chambreetage.jpg",
            "grandgite/chambreetage2.jpg",
            "grandgite/cheminee.jpg",
            "grandgite/SDB.jpg",
            "grandgite/table.jpg"
          ],
        },
        {
          title: "Les chambres d'hôtes",
          description: `Et si vous préférez la formule Chambres d’Hôtes, 3 belles pièces de caractère, très confortables ont été aménagées en rez-de-chaussée. 
              Elles sont climatisées et équipées d’une tv.
             L’une d’entre elles est labellisées « Tourisme et Handicap ». Nous serons ravis de vous préparer un petit déjeuner « fait maison », élaboré avec des produits locaux et de saison. `,
          subDesc: `Les 3 chambres sont situées au rez-de-chaussée de la bâtisse. Une d’entre elles est accessible aux personnes à mobilité réduite.<br/>
              Climatisation, TV, accès wifi<br/>
              Literie confortable<br/>
              Les petits-déjeuners ont la réputation d’être copieux et gourmands. « Fait maison » garanti !<br/>
              `,
          imgs: [
            "Chambredhote/03.jpg",
            "Chambredhote/06.jpg",
            "Chambredhote/07.jpg",
          ],
        },
        {
          title: "L'escale",
          description: `
           Pour un séjour plus tranquille, le temps d’un week-end ou plus, le petit gîte pour 2 personnes vous offre tout le confort et le calme dont vous rêvez.
           Charmant petit gîte pour une ou 2 personnes.<br/>
          Confortable et climatisé.<br/>
          Idéal pour découvrir notre territoire en toute indépendance<br/>
           Vous êtes tout à fait autonomes et vivez à votre rythme.
           `,
          subDesc: `Cet hébergement de caractère, avec ses murs en pierre, correspond parfaitement à ceux qui souhaitent profiter des activités et des découvertes en toute liberté. <br/>
            Vous serez complètement autonomes et indépendants. <br/>
            Pièce de vie avec cuisine équipée, accès wifi, TV, climatisation. <br/>
            Chambres indépendante avec salle d’eau. WC
            `,
          imgs: [
            "Studio/Studio A.jpg",
            "Studio/Studio.jpg",
            "Studio/Studio B.jpg",
            "Studio/Studio C.jpg",
            "Studio/Studio D.jpg",
          ],
        },
      ],
    };
  },
  created() {
    switch (this.$route.params.type) {
      case "le-gite":
        this.categorie = 0;
        break;
      case "chambres-d-hotes":
        this.categorie = 1;
        break;
      case "studio":
        this.categorie = 2;
        break;
      default:
        this.categorie = 0;
        break;
    }
  },

  methods: {
    getImg(img) {
      return require("@/assets/images/" + img);
    },
  },
};
</script>

<style>
.filNav span {
  margin: 0 4px;
}

.presentation {
  display: flex;
}

.presentation>* {
  width: 50%;
}

.presentation .somePadd {
  padding-top: 5%;
}

.presentation div:first-child p {
  max-width: 70%;
}

.italic {
  font-style: italic;
}

.presentation h2 {
  font-size: 3rem;
  margin: 0;
  font-weight: 100;
  font-variation-settings: "wght" 1000;
  color: var(--dark-color);
  font-family: "Dancing", Avenir, Helvetica, Arial, sans-serif;
}

.biggerText {
  font-size: 1.3rem;
  font-weight: 100;
}

.resaBtnBox {
  display: flex;
  justify-content: space-evenly;
  max-width: 70%;
  margin-top: 2rem;
}

.resaBtnBox a {
  color: var(--dark-color);
  padding: 1rem 2.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 0 0px 2px var(--dark-color);
  font-weight: bold;
}

.resaBtnBox a:hover {
  background-color: var(--dark-color);
  color: white;
  transition: all 0.3s ease;
}

.bigsmallsImgBoxEl {
  height: 400px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.theBigImg {
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: all 0.5s ease;
}

.navSlide .imageContainer>* {
  padding: 0 8px;
}

.navSlide .slideBtn {
  background: white;
  border-radius: 40%;
  padding: 4px 8px;
}

.navSlide .btnLeft {
  left: 0;
}

.navSlide .btnRight {
  right: 0;
}

.scrollXImg {
  overflow-x: auto;
  position: relative;
}

.arrowNav:first-child {
  right: unset;
  left: 0;
}

.smallsImgBox {
  display: inline-flex;
  justify-content: space-between;
  width: fit-content;
}

.smallsImgBox>* {
  width: 29%;
  height: 160px;
  object-fit: cover;
  margin-right: 1%;
  cursor: pointer;
}

.situationText {
  font-size: 1.1rem;
}

.situationText a {
  text-decoration: underline;
  text-decoration-color: dimgray;
}

.imgFade-enter-active,
.imgFade-leave-active {
  transition: opacity 0.5s;
}

.imgFade-leave-to {
  display: none;
}

.imgFade-enter {
  opacity: 0.8;
}

.tarifsSection {}

.imgViewer .imageContainer>*>* {
  object-fit: contain;
}

.imgViewer .slideBtn {
  height: 50px;
  width: 50px;
  background: white;
  border-radius: 50%;
  border: 2px var(--dark-color) solid;
  color: var(--dark-color);
}

.imgViewer .btnLeft {
  left: -25px;
}

.imgViewer .btnRight {
  right: -25px;
}

.imgViewer .slideBtn:hover {
  background: var(--dark-color);
  color: white;
  transition: 0.3s ease;
}

table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  margin-bottom: 2rem;
}

tr:nth-child(even) {
  background: #fff;
}

th,
tr:nth-child(odd) {
  background: rgb(228, 236, 218);
}

th,
td {
  padding: 1rem 0;
}

.notcurrImg {
  opacity: 0.7;
  transition: all 0.3s ease;
}

@media all and (max-width: 1400px) {
  .giteContainer {
    margin: 0 5%;
  }

  .presentation div:first-child p {
    max-width: 90%;
  }
}

@media all and (max-width: 1100px) {
  .presentation {
    flex-direction: column;
  }

  .presentation>* {
    width: 100%;
  }

  .presentation .somePadd {
    padding-bottom: 5%;
    padding-top: 0;
  }

  .resaBtnBox {
    max-width: 100%;
  }

  .somePadd h2 {
    margin-bottom: 0;
  }

  .biggerText {
    margin-top: 0;
  }
}

@media all and (max-width: 1000px) {
  .filNav {
    display: none;
  }
}

@media all and (max-width: 768px) {
  .giteContainer {
    margin: 0 8px;
  }

  .tarifsSection {
    overflow-x: scroll;
  }

  table {
    min-width: 700px;
  }

  .arrowNav {
    display: none;
  }

  .smallsImgBox {
    flex-wrap: wrap;
  }

  .smallsImgBox>* {
    width: 32%;
    height: 70px;
    margin-bottom: 4px;
  }
}

@media all and (max-width: 400px) {
  .resaBtnBox {
    flex-direction: column;
  }

  .resaBtnBox a {
    margin: 8px 0;
    text-align: center;
  }
}
</style>